import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SignalLoss = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M19 28C18.448 28 18 27.552 18 27C18 19.832 12.168 14 5 14C4.448 14 4 13.552 4 13C4 12.448 4.448 12 5 12C13.271 12 20 18.729 20 27C20 27.552 19.552 28 19 28Z" />
		<path d="M27 28C26.448 28 26 27.552 26 27C26 21.386 23.817 16.111 19.853 12.147C15.889 8.183 10.614 6 5 6C4.448 6 4 5.552 4 5C4 4.448 4.448 4 5 4C11.148 4 16.925 6.391 21.267 10.733C25.609 15.075 28 20.852 28 27C28 27.552 27.552 28 27 28V28Z" />
		<path d="M9.414 24C10.645 22.769 11.707 21.707 11.707 21.707C11.888 21.526 12 21.276 12 21C12 20.448 11.552 20 11 20C10.724 20 10.474 20.112 10.293 20.293C10.293 20.293 9.23 21.356 8 22.586C6.769 21.355 5.707 20.293 5.707 20.293C5.526 20.112 5.276 20 5 20C4.448 20 4 20.448 4 21C4 21.276 4.112 21.526 4.293 21.707C4.293 21.707 5.355 22.769 6.586 24C5.355 25.231 4.293 26.293 4.293 26.293C4.112 26.474 4 26.724 4 27C4 27.552 4.448 28 5 28C5.276 28 5.526 27.888 5.707 27.707C5.707 27.707 6.769 26.645 8 25.414C9.231 26.645 10.293 27.707 10.293 27.707C10.474 27.888 10.724 28 11 28C11.552 28 12 27.552 12 27C12 26.724 11.888 26.474 11.707 26.293C11.707 26.293 10.644 25.23 9.414 24V24Z" />
	</svg>
);

export default SignalLoss;
